import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Carousel, EmbeddedVideo } from 'cat-ecommerce-alloy';
import {
  IMAGE_URL,
  SCENE7_PRESETS
} from '../../../../constants/commonConstants';
import styles from './ProductCarousel.module.scss';

const CAROUSEL_FALLBACK_URL = `${IMAGE_URL}/CM20170508-76204-57647?${SCENE7_PRESETS.PDP2}`;
const CAROUSEL_LIMIT = 7;
const PRODUCT_IMAGE_SIZE = '320px';

// TODO: Move this to Alloy?
const ProductCarousel = ({
  className,
  images = [],
  initialContent,
  fallbackOverlay,
  videoWarningMessage,
  showWarning
}) => {
  const [t] = useTranslation();
  const defaultTitle = t('IMAGE_NOT_AVAILABLE');
  const carouselPartsImages = images?.slice(0, CAROUSEL_LIMIT);

  const getSmallImages = (url, title) => {
    const urlWithPreset = `${url}?${SCENE7_PRESETS.PDP2}`;
    return (
      <div key={urlWithPreset}>
        <img
          src={urlWithPreset}
          alt={title}
          width={PRODUCT_IMAGE_SIZE}
          height={PRODUCT_IMAGE_SIZE}
          draggable="false"
          loading="lazy"
        />
      </div>
    );
  };
  const getEmbeddedVideo = (url, title) => {
    return showWarning ? (
      videoWarningMessage
    ) : (
      <EmbeddedVideo
        key={url}
        url={url}
        title={title}
        width={PRODUCT_IMAGE_SIZE}
        height={PRODUCT_IMAGE_SIZE}
        className="ratio-21x9"
      />
    );
  };
  const getImageOrVideo = () =>
    carouselPartsImages?.map(({ url, title = defaultTitle, type }) =>
      type === 'video'
        ? getEmbeddedVideo(url, title)
        : getSmallImages(url, title)
    );

  return (
    <Carousel
      className={cx('w-100 text-center', styles['product-carousel'], className)}
      fallbackImage={CAROUSEL_FALLBACK_URL}
      defaultTitle={defaultTitle}
      width={PRODUCT_IMAGE_SIZE}
      height={PRODUCT_IMAGE_SIZE}
      initialContent={initialContent}
      fallbackOverlay={fallbackOverlay}
    >
      {getImageOrVideo()}
    </Carousel>
  );
};

ProductCarousel.propTypes = {
  className: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      type: PropTypes.string,
      title: PropTypes.string
    })
  ),
  initialContent: PropTypes.node,
  fallbackOverlay: PropTypes.node,
  videoWarningMessage: PropTypes.string,
  showWarning: PropTypes.bool
};

export default ProductCarousel;
